import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

export const getEventComments = async () => {
  const response = await axiosInstance.get(`${API_URL}/event-comments`);
  return response.data;
};

export const getEventCommentsByEventId = async (eventId) => {
  const response = await axiosInstance.get(`${API_URL}/event-comments`, {
    params: { eventId },
  });
  return response.data;
};

export const getEventCommentsByEventIds = async (eventIds = []) => {
  if (!eventIds.length) {
    return [];
  }

  const response = await axiosInstance.get(
    `${API_URL}/event-comments/by-event-ids`,
    {
      params: { eventIds: eventIds.join(",") },
    },
  );
  return response.data;
};

export const getEventCommentById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/event-comments/${id}`);
  return response.data;
};

export const createEventComment = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/event-comments`, data);
  return response.data;
};

export const updateEventComment = async (id, data) => {
  const response = await axiosInstance.put(
    `${API_URL}/event-comments/${id}`,
    data,
  );
  return response.data;
};

export const deleteEventComment = async (id) => {
  const response = await axiosInstance.delete(
    `${API_URL}/event-comments/${id}`,
  );
  return response.data;
};
